import React from "react";
import { Link } from 'react-router-dom';
import { Empty } from 'antd';

const Component = ({ location }) => (
    <div style={{
        display: 'table',
        width: '100%',
        height: '100vh',
        textAlign: 'center'
    }}>
        <div style={{
            display: 'table-cell',
            verticalAlign: 'middle'
        }}>
            <Empty />
            <h4>"{location.pathname}"</h4>
            <Link to="/app">Ir a citas</Link>
        </div>
    </div>
);

export default Component;